import { Component, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppRoute } from '@app/core/enums/app-route.enum';

export interface MenuItemConfig {
    id: string;
    label: string;
    icon?: string; // SVG path or icon name
    action?: () => void;
    type?: 'default' | 'logout' | 'custom';
}

@Component({
    selector: 'app-user-menu',
    template: '', // Non-visible component
    styleUrls: ['./user-menu.component.scss']
})
export class UserMenuComponent implements AfterViewInit {

    private readonly ccEmail = "quilt.support@quantumcap.com";
    private readonly toEmail = "helpdesk@quantumcap.com";
    private readonly mailSubject = "QUILT Support Question";
    private readonly mailBody = "Describe your support issue here:";

    private readonly menuItems: MenuItemConfig[] = [
        { 
            id: 'profile', 
            label: 'Profile', 
            icon: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12,19.2C9.5,19.2 4,20.9 4,23.4V24H20V23.4C20,20.9 14.5,19.2 12,19.2M12,17A5,5 0 1,0 7,12A5,5 0 0,0 12,17Z" fill="currentColor"/></svg>',
            action: () => this.profile() 
        },
        { 
            id: 'support', 
            label: 'Email support team', 
            icon: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M1.5,8.67V17.25C1.5,18.29 2.34,19.13 3.38,19.13H20.63C21.66,19.13 22.5,18.29 22.5,17.25V8.67L12.56,15.3C12.23,15.52 11.78,15.52 11.44,15.3L1.5,8.67Z" fill="currentColor"/><path d="M22.5,6.91V6.75C22.5,5.71 21.66,4.88 20.63,4.88H3.38C2.34,4.88 1.5,5.71 1.5,6.75V6.91L11.44,13.54C11.78,13.76 12.23,13.76 12.56,13.54L22.5,6.91Z" fill="currentColor"/></svg>',
            action: () => this.openMail()
        },
    ];

    constructor(
        private readonly router: Router,
    ) { }

    ngAfterViewInit(): void {
        const mainToolbar = document.querySelector('qds-main-toolbar');

        if (!mainToolbar) {
            return;
        }

        let avatarElement = mainToolbar?.shadowRoot?.querySelector('qds-auth-avatar');

        if (!avatarElement) {
            return;
        }

        this.addMenuItemsToAvatar(avatarElement);
    }

    private addMenuItemsToAvatar(avatarElement: any): void {
        this.menuItems.forEach(menuItem => {
            avatarElement.addMenuItem(menuItem.id, menuItem);
        });
    }

    private openMail() {
        const to = encodeURIComponent(this.toEmail || '');
        const cc = encodeURIComponent(this.ccEmail || '');
        const subject = encodeURIComponent(this.mailSubject || '');
        const body = encodeURIComponent(this.mailBody || '');

        const mailtoLink = `mailto:${to}?cc=${cc}&subject=${subject}&body=${body}`;
        window.open(mailtoLink, '_blank');
    }

    private profile() {
        this.router.navigateByUrl(AppRoute.User);
    }

}
